import Black_Combo_Logo from '../../assets/img/black_combo_logo.png';
import White_Combo_Logo from '../../assets/img/white_combo_logo.png';
import Dakar_White_Logo from '../../assets/img/dakar_white_logo.png';
import Dakar_Black_Logo from '../../assets/img/dakar_black_logo.png';
import {
    AUTH_REDIRECT_SIGN_IN,
    AUTH_REDIRECT_SIGN_OUT,
    AUTH_REDIRECT_SIGN_IN_DAKAR,
    AUTH_REDIRECT_SIGN_OUT_DAKAR,
    IDENTITY_PROVIDER_DAKAR,
    IDENTITY_PROVIDER_MICO,
} from './configs';

// Configuração por domínio/tenant
export const getTenantConfig = () => {
    const hostname = window.location.hostname;
    
    const dakarConfig = {
        tenantId: 'DAKAR',
        loginLogo: Dakar_White_Logo,
        headerLogo: Dakar_Black_Logo,
        showMicoLogin: true,
        ssoButtonLabel: 'Login Dakar',
        latitude: "14.748769790829723",
        longitude: "-17.273623644006875",
        zoom: 11,
        identityProvider: IDENTITY_PROVIDER_DAKAR,
        redirectSignIn: AUTH_REDIRECT_SIGN_IN_DAKAR,
        redirectSignOut: AUTH_REDIRECT_SIGN_OUT_DAKAR,
        };

    const iocConfig = {
        tenantId: 'IOC',
        loginLogo: Black_Combo_Logo, // Logo para login (preto)
        headerLogo: White_Combo_Logo, // Logo para header (branco)
        showMicoLogin: true,
        ssoButtonLabel: 'Login MiCo',
        latitude: "45.7817252",
        longitude: "9.6885903",
        zoom: 8,
        identityProvider: IDENTITY_PROVIDER_MICO,
        redirectSignIn: AUTH_REDIRECT_SIGN_IN,
        redirectSignOut: AUTH_REDIRECT_SIGN_OUT,
    };

    // Configuração para Dakar (check first - more specific)
    if (hostname.includes('dakar') && hostname.includes('dttsynergy.com')) {
        return dakarConfig;
    }

    // Configuração para IOC
    if (hostname.includes('ioc') && hostname.includes('dttsynergy.com')) {
        return iocConfig;
    }

    // Configuração para localhost (desenvolvimento)
    if (hostname.includes('localhost')) {
        return dakarConfig;
    } 

    // Configuração padrão (fallback)
    return {
        tenantId: 'DEFAULT',
        loginLogo: Black_Combo_Logo,
        headerLogo: White_Combo_Logo,
        showMicoLogin: true,
        ssoButtonLabel: 'Login SSO',
        latitude: "45.7817252",
        longitude: "9.6885903",
        zoom: 8,
        identityProvider: process.env.REACT_APP_IDENTITY_PROVIDER_MICO,
        redirectSignIn: AUTH_REDIRECT_SIGN_IN,
        redirectSignOut: AUTH_REDIRECT_SIGN_OUT,
    };
};
